document.addEventListener("DOMContentLoaded", () => {
  const input = document.querySelector(".footer__search");
  const button = document.querySelector(".footer__search-button");
  const form = document.querySelector("#footer__search");

  if (!input || !button || !form) return;

  const toggle = () => {
    button.disabled = !input.value.trim();
  };

  input.addEventListener("input", toggle);

  form.addEventListener("submit", (e) => {
    if (!input.value.trim()) {
      e.preventDefault();
      input.focus();
    }
  });

  toggle();
});
